import React from 'react';
import moment from 'moment';

const statusMap = {
  todo: '未执行',
  running: '执行中',
  finished: '已完成',
};
export default self => [
  {
    title: '任务名称',
    dataIndex: 'name',
    key: 'name',
    width: 120,
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 90,
    render: t => statusMap[t],
  },
  {
    title: '采集源URL',
    dataIndex: 'first_list_url',
    key: 'first_list_url',
  },
  {
    title: '采集数据合计',
    width: 130,
    dataIndex: 'result_count',
    key: 'result_count',
  },
  {
    title: '创建人',
    dataIndex: 'create_staff_name',
    key: 'create_staff_name',
  },
  {
    title: '组织机构',
    dataIndex: 'organization_name',
    key: 'organization_name',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 150,
    render: t => (t ? moment(t).format('YYYY-MM-DD HH:mm') : ''),
  },
  {
    title: '最后执行时间',
    dataIndex: 'last_run_time',
    key: 'last_run_time',
    width: 150,
    render: t => (t ? moment(t).format('YYYY-MM-DD HH:mm') : ''),
  },
  {
    title: '最后完成时间',
    dataIndex: 'last_finish_time',
    key: 'last_finish_time',
    width: 150,
    render: t => (t ? moment(t).format('YYYY-MM-DD HH:mm') : ''),
  },
  {
    title: '操作',
    dataIndex: 'x',
    key: 'x',
    width: 60,
    render: (t, item) => (
      <div>
        <a
          onClick={() => {
            self.setModals({
              key: 'updateForm',
              title: '编辑采集任务',
              item,
              visible: true,
            });
          }}
        >
          配置
        </a>
      </div>
    ),
  },
];
